/*globals window, document */
import {Component, createElement} from "rmlibrary/comp";
import {visibilityChange} from "rmlibrary/common/page-visibility";

export let canAutoPlayAudio = false;

export function testAutoplayAudio() {
    const vid = document.createElement('video')
    vid.src = "data:video/mp4;base64,AAAAHGZ0eXBpc29tAAACAGlzb21pc28ybXA0MQAAAAhmcmVlAAAC721kYXQhEAUgpBv/wAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA3pwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcCEQBSCkG//AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADengAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcAAAAsJtb292AAAAbG12aGQAAAAAAAAAAAAAAAAAAAPoAAAALwABAAABAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAAAB7HRyYWsAAABcdGtoZAAAAAMAAAAAAAAAAAAAAAIAAAAAAAAALwAAAAAAAAAAAAAAAQEAAAAAAQAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAACRlZHRzAAAAHGVsc3QAAAAAAAAAAQAAAC8AAAAAAAEAAAAAAWRtZGlhAAAAIG1kaGQAAAAAAAAAAAAAAAAAAKxEAAAIAFXEAAAAAAAtaGRscgAAAAAAAAAAc291bgAAAAAAAAAAAAAAAFNvdW5kSGFuZGxlcgAAAAEPbWluZgAAABBzbWhkAAAAAAAAAAAAAAAkZGluZgAAABxkcmVmAAAAAAAAAAEAAAAMdXJsIAAAAAEAAADTc3RibAAAAGdzdHNkAAAAAAAAAAEAAABXbXA0YQAAAAAAAAABAAAAAAAAAAAAAgAQAAAAAKxEAAAAAAAzZXNkcwAAAAADgICAIgACAASAgIAUQBUAAAAAAfQAAAHz+QWAgIACEhAGgICAAQIAAAAYc3R0cwAAAAAAAAABAAAAAgAABAAAAAAcc3RzYwAAAAAAAAABAAAAAQAAAAIAAAABAAAAHHN0c3oAAAAAAAAAAAAAAAIAAAFzAAABdAAAABRzdGNvAAAAAAAAAAEAAAAsAAAAYnVkdGEAAABabWV0YQAAAAAAAAAhaGRscgAAAAAAAAAAbWRpcmFwcGwAAAAAAAAAAAAAAAAtaWxzdAAAACWpdG9vAAAAHWRhdGEAAAABAAAAAExhdmY1Ni40MC4xMDE=";

    const result = vid.play()
    if (result && result.then) {
        return result.then(() => {
            return true;
        }, () => {
            return false;
        }).then((ret) => {
            canAutoPlayAudio = ret;
            return ret;
        })
    }
    return Promise.resolve(true);
}

export class VideoPlayer extends Component {

    static getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.playing !== nextProps.playing) {
            return {
                playing: typeof (nextProps.playing) === 'undefined' ? true : (nextProps.playing || false)
            };
        }
        return null;
    }

    static get canAutoPlayAudio() {
        return canAutoPlayAudio;
    }

    constructor(props) {
        super(props);
        this.state = {
            playing: typeof (props.playing) !== 'undefined' ?
                !!props.playing :
                (typeof (props.autoPlay) !== 'undefined' ?
                    !!props.autoPlay:
                    false
                ),
            isOffScreen: false,
            isPageVisible: false
        };

        this.checkPositioning = this.checkPositioning.bind(this);
        this.handleRef = this.handleRef.bind(this);
    }

    seekTo(num) {
        this.vid.currentTime = num;
    }

    checkPositioning() {
        if (!this.vid) return;
        let vidRect;
        if (typeof (this.props.getRect) === 'function') {
            vidRect = this.props.getRect(this);
        } else {
            vidRect = this.vid.getBoundingClientRect();
        }
        const windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const isOffScreen = (vidRect.top + vidRect.height) < 0 || vidRect.top > windowHeight;
        if (this.state.isOffScreen !== isOffScreen) {
            this.setState({ isOffScreen: isOffScreen })
        }
    }

    handleVisibilityChange(isVisible) {
        this.setState({isPageVisible: isVisible});
    }

    componentDidMount() {
        if (this.props.pauseWhenOffscreen) {
            window.addEventListener('scroll', this.checkPositioning);
            window.addEventListener('resize', this.checkPositioning);
            setTimeout(this.checkPositioning);
        }
        if (this.props.pauseWhenNotVisible) {
            this.visibleListener = visibilityChange(this.handleVisibilityChange.bind(this));
            this.setState({isPageVisible: this.visibleListener.isVisible()});
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.checkPositioning);
        window.removeEventListener('resize', this.checkPositioning);
        if (this.visibleListener) this.visibleListener.destroy();
    }

    handleRef(vid) {
        this.vid = vid;
        if (this.props.pauseWhenOffscreen) this.checkPositioning
    }

    play() {
        this.setState({
            playing: true
        });
        this.vid.play();
    }
    pause() {
        if (this.vid) this.vid.autoplay = false;
        this.setState({
            playing: false
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.playing !== this.state.playing || prevState.isOffScreen !== this.state.isOffScreen ||  prevState.isPageVisible !== this.state.isPageVisible) {
            if (this.state.playing &&
                (!this.props.pauseWhenOffscreen || !this.state.isOffScreen) &&
                (!this.props.pauseWhenNotVisible || this.state.isPageVisible)
            ) {
                this.vid.play();
            } else {
                this.vid.pause();
                this.vid.autoplay = false;
            }
        }
    }

    render() {
        let setControls, setLoop, returnOntimeupdate, returnOnready, returnOnbuffer, returnOnplay, returnOnpause, returnOndurationchange, returnOnended = null

        const { getRect, pauseWhenOffscreen, pauseWhenNotVisible, controls, loop, volume, playing, onTimeUpdate, onReady, onBuffer, onPlay, onPause, onDurationchange, onEnded, ...otherProps } = this.props; // eslint-disable-line no-unused-vars

        let setAutoplay = this.state.playing ? {'autoPlay' : true} : null;

        if(controls == "true" || controls) setControls = {'controls': true};
        if(loop == "true" || loop) setLoop = {'loop': true};
        if(onTimeUpdate) returnOntimeupdate = {'onTimeUpdate': onTimeUpdate};
        if(onReady) returnOnready = {'onCanPlay': onReady};
        if(onBuffer) returnOnbuffer = {'onWaiting': onBuffer};
        if(onPlay) returnOnplay = {'onPlay': onPlay};
        if(onPause) returnOnpause = {'onPause': onPause};
        if(onDurationchange) returnOndurationchange = {'onDurationChange': onTimeUpdate};
        if(onEnded) returnOnended = {'onEnded': onEnded};

        return (
                 <video
                    {...otherProps}
                     {...setControls}
                     {...setAutoplay}
                     {...setLoop}
                     volume={volume}
                     {...returnOntimeupdate}
                     {...returnOnready}
                     {...returnOnbuffer}
                     {...returnOnplay}
                     {...returnOnpause}
                     {...returnOndurationchange}
                     {...returnOnended}
                     ref={this.handleRef}
                     >
                  <source src={this.props.src} type="video/mp4"/>
                </video>
        );
    }
}
